function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#7361E4"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.3717 36C18.1088 36 17.8476 35.918 17.6248 35.7568C17.2097 35.456 17.0158 34.9389 17.1288 34.4399L18.6727 27.6385L13.4365 23.0465C13.0516 22.7104 12.9046 22.1783 13.0626 21.6914C13.2206 21.2054 13.6506 20.8614 14.1596 20.8143L21.0878 20.1853L23.8269 13.7751C24.0289 13.3041 24.4889 13 24.9999 13C25.511 13 25.971 13.3041 26.1729 13.774L28.9121 20.1853L35.8391 20.8143C36.3493 20.8603 36.7792 21.2054 36.9372 21.6914C37.0952 22.1774 36.9491 22.7104 36.5642 23.0465L31.328 27.6376L32.872 34.4388C32.9852 34.9389 32.7911 35.456 32.3761 35.7559C31.9621 36.0558 31.4101 36.0789 30.9741 35.8169L24.9999 32.2467L19.0258 35.8189C18.8238 35.9388 18.5988 36 18.3717 36ZM24.9999 30.7088C25.227 30.7088 25.4518 30.7698 25.654 30.8897L31.2921 34.2619L29.8349 27.8425C29.7309 27.3857 29.886 26.9087 30.2391 26.5996L35.1832 22.2635L28.642 21.6694C28.171 21.6264 27.766 21.3303 27.582 20.8964L24.9999 14.8471L22.4148 20.8973C22.2328 21.3283 21.8277 21.6244 21.3579 21.6674L14.8157 22.2615L19.7597 26.5976C20.1138 26.9076 20.2687 27.3837 20.1638 27.8416L18.7077 34.2608L24.3459 30.8897C24.5478 30.7698 24.7729 30.7088 24.9999 30.7088ZM21.0349 20.3093C21.0349 20.3093 21.0349 20.3104 21.0338 20.3113L21.0349 20.3093ZM28.963 20.3064L28.9641 20.3084C28.9641 20.3073 28.9641 20.3073 28.963 20.3064Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.5
});

var SvgDataverifiedMembership = function SvgDataverifiedMembership(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDataverifiedMembership, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dataverified_membership.0f6ec48b.svg";
export { ForwardRef as ReactComponent };